module.exports = __webpack_public_path__ + "img/i2.1a3f476d.png";